import _memoize from 'lodash/memoize';
import { PRIMARY, TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { safetyMargins, FULL_HD, HD } from '@bedrock-rdk/constants';
import { WIDTH, EXPANDED_WIDTH } from './sidenav.constants';
import { makeDefaultStylingContext } from '../tornado/utils/style';
import { identity, SCREEN_HEIGHT, SCREEN_WIDTH } from '../tornado/utils/sizes';
import { BRAND_ICON_WIDTH_RATIO } from '../tornado/brand-icon/brandIcon.constants';
import { HEIGHT } from './miniPlayer/miniPlayer.style';

export { CONTENT_GAP } from './sidenav.constants';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  background: makeThemeColor(TERTIARY),
  border: makeThemeColor(PRIMARY, 0.3),
  overlay: makeThemeColor(TERTIARY),
  empty: makeThemeColor(TERTIARY, 0),
};

export const MAIN_LOGO_HEIGHT = {
  [HD]: 72,
  [FULL_HD]: 96,
};

export const KIDS_LOGO_WIDTH = {
  [HD]: 216,
  [FULL_HD]: 280,
};

export const getKidsIconViewBox = _memoize(screenSize => ({
  w: KIDS_LOGO_WIDTH[screenSize],
  h: MAIN_LOGO_HEIGHT[screenSize],
}));

export const getMainIconViewBox = _memoize(screenSize => ({
  h: MAIN_LOGO_HEIGHT[screenSize],
  w: MAIN_LOGO_HEIGHT[screenSize] * BRAND_ICON_WIDTH_RATIO,
}));

export const LOGO_MARGIN_BOTTOM = {
  [HD]: 56,
  [FULL_HD]: 96,
};

export const PADDING_TOP = {
  [HD]: 40,
  [FULL_HD]: 56,
};

export const ITEM_GAP = {
  [HD]: 24,
  [FULL_HD]: 36,
};

export const PADDING_BOTTOM = {
  [HD]: safetyMargins.vertical[HD],
  [FULL_HD]: safetyMargins.vertical[FULL_HD],
};

export const PADDING_LEFT = {
  [HD]: safetyMargins.horizontal[HD],
  [FULL_HD]: safetyMargins.horizontal[FULL_HD],
};

export const MINI_PLAYER_MARGIN = {
  [HD]: 16,
  [FULL_HD]: 24,
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;

  return {
    alpha: 0,
    color: colors.background[colorMode],
    w: WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    Gradient: {
      alpha: 0,
      x: EXPANDED_WIDTH[screenSize] / 2,
      rect: true,
      w: SCREEN_WIDTH[screenSize] - EXPANDED_WIDTH[screenSize],
      h: SCREEN_HEIGHT[screenSize],
      colorLeft: colors.overlay[colorMode],
      colorRight: colors.empty[colorMode],
    },
    Items: {
      w: WIDTH[screenSize],
      h: SCREEN_HEIGHT[screenSize],
    },
    Border: {
      x: EXPANDED_WIDTH[screenSize] - 1,
      alpha: 0,
      w: 1,
      h: SCREEN_HEIGHT[screenSize],
      color: colors.border[colorMode],
    },
    Logo: {
      alpha: 0,
      x: PADDING_LEFT[screenSize],
      y: PADDING_TOP[screenSize],
    },
    MiniPlayerWrapper: {
      mountY: 1,
      y: SCREEN_HEIGHT[screenSize] - safetyMargins.vertical[screenSize],
      w: value => value - MINI_PLAYER_MARGIN[screenSize] * 2,
      h: HEIGHT[screenSize],
      MiniPlayer: {
        x: MINI_PLAYER_MARGIN[screenSize],
        w: identity,
      },
    },
  };
};
